import TagsService from "external-services/tags-service";
import PouchActions, {PouchDocType} from "app/actions/pouch.actions";

const NS = 'TagsCtrl';

export default function TagsCtrl(
  $rootScope, $scope, $mdDialog, $filter, $mdToast, $timeout, unregister, hardCodedTags
) {
  "ngInject";

  const vm = this;
  const listeners = [];
  let highestOrder;
  let saveInterval;

  //-- define public properties
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;
  vm.waitingToSave = false;
  vm.SHARED_TAG_TYPE = hardCodedTags.SHARED_TAG_TYPE;
  //-- define public methods
  vm.newTag = newTag;
  vm.deleteTag = deleteTag;
  vm.editTag = editTag;
  vm.moveUp = moveUp;
  vm.moveDown = moveDown;
  vm.tryAgain = tryAgain;
  vm.save = save;
  //-- listen
  // listeners.push($rootScope.$on('pouch-synced-doctype-tag', getTags));
  listeners.push(PouchActions.handlePouchSyncedDoctype(PouchDocType.tag, () => getTags()));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  getTags();

  function moveUp(index, tag) {
    var tagAbove = vm.venueTagsList[index - 1];
    var aboveOrder = tagAbove.order;
    tagAbove.order = tag.order;
    tag.order = aboveOrder;
    vm.venueTagsList = $filter('orderBy')(vm.venueTagsList, function (item) { return item.order ? item.order : 0; });
    saveDelay();
  }

  function moveDown(index, tag) {
    var tagBelow = vm.venueTagsList[index + 1];
    var belowOrder = tagBelow.order;
    tagBelow.order = tag.order;
    tag.order = belowOrder;
    vm.venueTagsList = $filter('orderBy')(vm.venueTagsList, function (item) { return item.order ? item.order : 0; });
    saveDelay();
  }

  function saveDelay() {
    vm.waitingToSave = true;
    if (saveInterval) {
      $timeout.cancel(saveInterval);
    }
    saveInterval = $timeout(save, 2000);
  }

  function save() {
    if (saveInterval) {
      $timeout.cancel(saveInterval);
    }
    vm.state = vm.LOADING;
    TagsService.saveTags(vm.venueTagsList).then(function () {

      vm.state = vm.ENTER;
      $mdToast.show(
        $mdToast.simple()
          .content('Tags Saved')
          .position('bottom right')
          .theme('saved')
          .hideDelay(3000)
      );
    }).catch(function () {
      vm.state = vm.ERROR;
    });
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function getTags() {
    TagsService.getTags(true).then(function (tagsList) {
      vm.sharedTagsList = tagsList.filter((tag) => {
        return tag.tagtype &&
          (tag.tagtype._id === hardCodedTags.SHARED_TAG_TYPE
            || tag._id === hardCodedTags.DELIVERY_TAG_ID
            || tag._id === hardCodedTags.VERIFIED_TAG_ID)
      });

      var venueTags = tagsList.filter((tag) => {
        return !tag.tagtype ||
          (tag.tagtype._id !== hardCodedTags.SHARED_TAG_TYPE
            && tag._id !== hardCodedTags.DELIVERY_TAG_ID
            && tag._id !== hardCodedTags.VERIFIED_TAG_ID);
      });

      var orderList = $filter('orderBy')(venueTags, function (item) { return item.order ? item.order : 0; });
      var lastOrder = 0;
      for (var i = 0; i < orderList.length; i++) {
        var tag = orderList[i];
        if (!isNaN(tag.order)) {
          if (tag.order === lastOrder) {
            tag.order = lastOrder += 1;
          }
        } else {
          tag.order = lastOrder += 1;
        }
        lastOrder = tag.order;
      }
      highestOrder = lastOrder;
      vm.venueTagsList = orderList;
      if (vm.state === vm.LOADING) {
        vm.state = vm.ENTER;
      }
      vm.waitingToSave = false;
    });
  }

  function newTag(evt) {
    $mdDialog.show({
      controller: 'TagEditorCtrl',
      controllerAs: 'tagEditorCtrl',
      clickOutsideToClose: true,
      locals: {
        tag: null,
        highestOrder: highestOrder
      },
      templateUrl: 'app/settings/tags/tagEditor.html',
      targetEvent: evt
    });
  }

  function editTag(evt, tag) {
    $mdDialog.show({
      controller: 'TagEditorCtrl',
      controllerAs: 'tagEditorCtrl',
      clickOutsideToClose: true,
      locals: {
        tag: tag,
        highestOrder: highestOrder
      },
      templateUrl: 'app/settings/tags/tagEditor.html',
      targetEvent: evt
    });
  }

  function deleteTag(evt, tag) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Are you sure?')
      .content('Delete tag ' + tag.tagtype.name + ' ' + tag.name)
      .ariaLabel('Delete tag')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      TagsService.deleteTag(tag);
    });
  }
}
